import { useAppSelector } from '../../redux/app/hooks'
import { selectedTheme } from '../../redux/slices/theme/themeSlice'

const useIPTheme = () => {
  return useAppSelector(selectedTheme)
}

export default useIPTheme
